import React from 'react'
import 'lazysizes'
import queryString from 'query-string'

import {
  MobileContainer,
  IplLogo
} from '../components/IbcArcade/LandingPage/styledComponents'
import { HeaderElement } from '../components/Header/styledComponents'
import Header from '../components/Header'
import Footer from '../components/core/Footer'
import SEO from '../components/core/SEO'
import LandingPage from '../components/IbcArcade/LandingPage'
import PlayInInternationalStadiumStrip from '../components/IbcArcade/PlayInInternationalStrip'
import TestimonialSection from '../components/IbcArcade/TestimonialSection'
import MapSection from '../components/IbcArcade/MapSection'
import ArcadeGallery from '../components/IbcArcade/ArcadeGallery'
import darkTheme from '../constants/themeConstants/darkTheme'

class ArcadeTemplate extends React.Component {
  queryParams = {}

  state = {
    parsedQueryParams: false
  }

  isOnePlusOneOfferPresent = () => {
    if (this.queryParams) {
      if (this.queryParams.utm_campaign) {
        return this.queryParams.utm_campaign.includes('1Offer')
      }
    }
    return false
  }

  getPriceCardsData = () => {
    const { data } = this.props
    const { parsedQueryParams } = this.state
    if (data && parsedQueryParams) {
      const { arcadePageData: { edges: arcadesPageData } } = data
      const {
        priceCardsData,
        customPriceCardsData
      } = arcadesPageData[0].node.frontmatter
      if (this.isOnePlusOneOfferPresent()) {
        return customPriceCardsData
      }
      return priceCardsData
    }
    return null
  }

  render() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.queryParams = queryString.parse(window.location.search)
      if (this.state.parsedQueryParams === false)
        this.setState({ parsedQueryParams: true })
    }
    const { data, headerPropsData, footerProps, bookNowModalData } = this.props
    if (data) {
      const {
        arcadePageData: { edges: arcadesPageData },
        arcadePageInterNationalStripData: {
          edges: arcadePagesInterNationalStripData
        }
      } = data
      const {
        mapSectionData,
        landingPageData,
        arcadeGalleryData,
        bookingResponseData,
        arcadeSEOData,
        termsAndConditionsData,
        pagePrefix
      } = arcadesPageData[0].node.frontmatter

      const {
        playInInternationalStrip
      } = arcadePagesInterNationalStripData[0].node.frontmatter
      return (
        <div>
          <SEO SEOData={arcadeSEOData} />
          <Header
            headerPropsData={headerPropsData}
            hideLogoByDefault
            isSimpleNavigation={false}
            headerComponent={HeaderElement}
            showBookSlot={false}
            showBookSlotInSideNav={false}
            bookNowModalData={bookNowModalData}
          />
          <MobileContainer iplUrl={landingPageData.mobileIplImageUrl}>
            <IplLogo src={landingPageData.mobileIplImageUrl} alt="Ipl logo" />
          </MobileContainer>
          <LandingPage
            amanoraSectionDetails={mapSectionData}
            landingPageDetails={landingPageData}
            termsAndConditionsData={termsAndConditionsData}
            bookingResponseData={bookingResponseData}
            pagePrefix={pagePrefix}
            priceCardsData={this.getPriceCardsData()}
            isOnePlusOneOfferPresentInPriceCards={this.isOnePlusOneOfferPresent()}
          />

          <PlayInInternationalStadiumStrip
            playInInternationalStrip={playInInternationalStrip}
            pagePrefix={pagePrefix}
            amanoraSectionDetails={mapSectionData}
            landingPageDetails={landingPageData}
            termsAndConditionsData={termsAndConditionsData}
            bookingResponseData={bookingResponseData}
          />
          <TestimonialSection
            pagePrefix={pagePrefix}
            amanoraSectionDetails={mapSectionData}
            landingPageDetails={landingPageData}
            termsAndConditionsData={termsAndConditionsData}
            bookingResponseData={bookingResponseData}
          />
          <ArcadeGallery
            arcadeGalleryData={arcadeGalleryData}
            pagePrefix={pagePrefix}
            amanoraSectionDetails={mapSectionData}
            landingPageDetails={landingPageData}
            termsAndConditionsData={termsAndConditionsData}
            bookingResponseData={bookingResponseData}
            priceCardsData={this.getPriceCardsData()}
          />
          <MapSection
            amanoraSectionDetails={mapSectionData}
            pagePrefix={pagePrefix}
          />
          <Footer {...footerProps} theme={darkTheme.footerSection} />
        </div>
      )
    }
    return null
  }
}

export default ArcadeTemplate

// eslint-disable-next-line
export const pageQuery = graphql`
  query ArcadePageByPath($path: String!) {
    arcadePageData: allMarkdownRemark(
      filter: { frontmatter: { path: { eq: $path } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            path
            type
            pagePrefix
            mapSectionData {
              heading
              description
              arcadeMapUrl
              addressHeading
              address
              landmarkHeading
              landmark
              contactNoHeading
              contactNumber
            }
            landingPageData {
              heading
              mobileIplImageUrl
              logoimageurl
              desktopdescription
              mobiledescription
              skewsectioncontent
              buttontext
              nowatcontent
              nowatmobilecontent
              desktopbgvideomp4
              desktopbgvideowebm
              desktopvideoposter
              tabletbgvideomp4
              tabletbgvideowebm
              tabletvideoposter
              mobilebgvideomp4
              mobilebgvideowebm
              mobilevideoposter
            }
            priceCardsData {
              priceCardsDesktopImagesList {
                imageUrl
                altText
                buttonText
                buttonRedirectText
                cardId
                isMembershipCard
                membershipCardModalData {
                  imageUrl
                  imageAltText
                  visitArcadeText
                  packageText
                }
              }
              priceCardsMobileImagesList {
                imageUrl
                altText
                buttonText
                buttonRedirectText
                cardId
                isMembershipCard
                membershipCardModalData {
                  imageUrl
                  imageAltText
                  visitArcadeText
                  packageText
                }
              }
            }
            customPriceCardsData {
              priceCardsDesktopImagesList {
                imageUrl
                altText
                cardId
              }
              priceCardsMobileImagesList {
                imageUrl
                altText
                cardId
              }
            }
            arcadeGalleryData {
              galleryDesktopImageUrl
              galleryMobileImageUrl
              galleryImageAltText
              galleryThumbnailUrl
            }
            bookingResponseData {
              thankYouWishes
              thankYouMessage
              bookAnotherButtonText
              continueButtonText
              bookingDetailsHeading
              bookingIDPrefix
              arcadeFormMauticID
              arcadeCity
              arcadeClosingDate
              arcadeClosingEndDate
              arcadeClosedDatesList
            }
            arcadeSEOData {
              title
              description
              ogTitle
              ogUrl
              ogImage
              ogDescription
              ogSiteName
              ogType
              twitterTitle
              twitterUrl
              twitterDescription
              twitterImage
              twitterSite
              schemaData
              canonicalUrl
              isRobotsTextEnabled
            }
            termsAndConditionsData {
              heading
              description
            }
          }
        }
      }
    }
    arcadePageInterNationalStripData: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/international-strip-data/" }
      }
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            title
            playInInternationalStrip {
              description
              svg
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/arcade-pages-template.js